import axios from 'axios';
import { TERMS_VERSION } from '../legal/terms';

// Returns the terms version the user last accepted, or null.
// Rejects on network/server error so the caller can tell a real "not accepted"
// response apart from the backend simply being unreachable.
export function getAcceptedTermsVersion() {
    return axios.get('/terms/acceptance')
        .then(res => (res && res.data ? res.data.version : null));
}

// Records acceptance of the current terms version.
export function acceptTerms(locale) {
    return axios.post('/terms/accept', { version: TERMS_VERSION, locale });
}

export function isCurrentTermsAccepted(acceptedVersion) {
    return acceptedVersion === TERMS_VERSION;
}



// WEBPACK FOOTER //
// ./src/api/terms.js